var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    { attrs: { wrap: "" } },
    [
      _c(
        "v-form",
        {
          ref: "form",
          model: {
            value: _vm.formIsValid,
            callback: function ($$v) {
              _vm.formIsValid = $$v
            },
            expression: "formIsValid",
          },
        },
        [
          _c("v-select", {
            attrs: {
              items: _vm.templateSelectionItems,
              label: "Static Content Template",
              rules: _vm.templateId.rules,
            },
            model: {
              value: _vm.templateId.value,
              callback: function ($$v) {
                _vm.$set(_vm.templateId, "value", $$v)
              },
              expression: "templateId.value",
            },
          }),
          _vm._v(" "),
          _c("v-divider"),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs12: "" } },
            [
              _c("StaticContentFormInfo", {
                attrs: { value: _vm.selectedTemplateName },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.itemDataFields, function (itemDataField, i) {
            return _c("v-text-field", {
              key: `input-${itemDataField}-${i}`,
              attrs: {
                label: _vm.capitalize(itemDataField),
                rules: _vm.formValidationRuleByName(itemDataField),
              },
              model: {
                value: _vm.itemData.value[itemDataField],
                callback: function ($$v) {
                  _vm.$set(_vm.itemData.value, itemDataField, $$v)
                },
                expression: "itemData.value[itemDataField]",
              },
            })
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }